(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cautiva-size-guide"] && !Shopify.designMode) return;
  try {
    if (!window.__cautivaSizeGuideInit) {
    window.__cautivaSizeGuideInit = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cautiva-size-guide-trigger]');
      if (trigger) {
        event.preventDefault();
        const targetId = trigger.getAttribute('data-cautiva-size-guide-trigger');
        const dialog = document.getElementById(targetId);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
        return;
      }

      const closeBtn = event.target.closest('[data-cautiva-size-guide-close]');
      if (closeBtn) {
        closeBtn.closest('dialog.cautiva-size-guide')?.close();
        return;
      }

      if (event.target.matches('dialog.cautiva-size-guide')) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
